import { defaultTreeProps, TreeProps } from '@theia/core/lib/browser';
import { Container, interfaces } from '@theia/core/shared/inversify';
import { createFileTreeContainer } from '@theia/filesystem/lib/browser';
import { FileNavigatorModel } from '@theia/navigator/lib/browser/navigator-model';
import { NAVIGATOR_CONTEXT_MENU } from '@theia/navigator/lib/browser/navigator-contribution';
import { NavigatorDecoratorService } from '@theia/navigator/lib/browser/navigator-decorator-service';
import { FileNavigatorTree } from '@theia/navigator/lib/browser/navigator-tree';
import { LvglFileNavigatorWidget } from './lvgl-file-navigator-widget';
import { isBrowserOnlyTheia } from '../online-preview/environment';

const FILE_NAVIGATOR_CONTEXT_MENU_PROPS: Partial<Pick<TreeProps, 'contextMenuPath'>> = isBrowserOnlyTheia()
    ? {}
    : { contextMenuPath: NAVIGATOR_CONTEXT_MENU };

const FILE_NAVIGATOR_PROPS: TreeProps = {
    ...defaultTreeProps,
    ...FILE_NAVIGATOR_CONTEXT_MENU_PROPS,
    multiSelect: true,
    search: true,
    globalSelection: true
};

export const createLvglFileNavigatorContainer = (parent: interfaces.Container): Container =>
    createFileTreeContainer(parent, {
        tree: FileNavigatorTree,
        model: FileNavigatorModel,
        widget: LvglFileNavigatorWidget,
        decoratorService: NavigatorDecoratorService,
        props: FILE_NAVIGATOR_PROPS
    });

export const createLvglFileNavigatorWidget = (parent: interfaces.Container): LvglFileNavigatorWidget =>
    createLvglFileNavigatorContainer(parent).get(LvglFileNavigatorWidget);
